import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataResiduosReciclados from "./dataResiduosReciclados";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const ResiduosReciclados = ({ listadoResiduosReciclados }) => {
  const { columns, getRows } = dataResiduosReciclados;

  const memoizedRows = useMemo(() => {
    if (listadoResiduosReciclados) {
      const listadoSinBorrar = listadoResiduosReciclados.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoResiduosReciclados]);

  return (
    <Grid container p={2}>
      <Grid item xs={12}>
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Residuos Reciclados
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoResiduosReciclados?.filter((item) => !item.aBorrar).length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay residuos reciclados cargados" />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(ResiduosReciclados);

ResiduosReciclados.propTypes = {
  listadoResiduosReciclados: PropTypes.array.isRequired,
};
